import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/table-view.js";
import "@ui5/webcomponents-icons/dist/compare-2.js";
import "@ui5/webcomponents-icons/dist/bar-chart.js";
import "@ui5/webcomponents-icons/dist/tree.js";
import "@ui5/webcomponents-icons/dist/calendar.js";
import "@ui5/webcomponents-icons/dist/inbox.js";
import "@ui5/webcomponents-icons/dist/attachment.js";
import "@ui5/webcomponents-icons/dist/chain-link.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";
import "@ui5/webcomponents-icons/dist/table-chart.js";
import "@ui5/webcomponents-icons/dist/group.js";
import "@ui5/webcomponents-icons/dist/outgoing-call.js";
import "@ui5/webcomponents-icons/dist/ai.js";

import { aiSettingsPath, analyticsModule, analyticsPermissions as b } from "./analyticsPermissions";
import { reportsPermissions as p } from "./permissions";

/**
 * Reports entries of the navigation registry (group `reports`, plan module `gl`): the financial reports (part A) and the
 * dashboards (plan module `analytics`), query reports, footfall KPI and franchise exports (part B).
 */
export const reportsNavigation: readonly NavigationEntry[] = [
  {
    key: "reports.dashboards",
    labelKey: "nav.rptDashboards",
    icon: "business-objects-experience",
    path: "/reports/dashboards",
    permission: b.dashboardView,
    module: analyticsModule,
  },
  {
    key: "reports.queryReports",
    labelKey: "nav.rptQueryReports",
    icon: "table-chart",
    path: "/reports/query-reports",
    permission: b.queryReportView,
  },
  {
    key: "reports.footfall",
    subGroup: "analysis",
    labelKey: "nav.rptFootfall",
    icon: "group",
    path: "/reports/footfall",
    permission: b.footfallView,
  },
  {
    key: "reports.franchise",
    subGroup: "distribution",
    labelKey: "nav.rptFranchise",
    icon: "outgoing-call",
    path: "/reports/franchise-exports",
    permission: b.franchiseView,
  },
  {
    key: "reports.aiSettings",
    subGroup: "setup",
    labelKey: "nav.rptAiSettings",
    icon: "ai",
    path: aiSettingsPath,
    permission: b.aiSettingsView,
    module: analyticsModule,
  },
  {
    key: "reports.balanceSheet",
    labelKey: "nav.rptBalanceSheet",
    icon: "table-view",
    path: "/reports/balance-sheet",
    permission: p.balanceSheetView,
  },
  {
    key: "reports.incomeStatement",
    labelKey: "nav.rptIncomeStatement",
    icon: "table-view",
    path: "/reports/income-statement",
    permission: p.incomeView,
  },
  {
    key: "reports.comprehensiveIncome",
    subGroup: "analysis",
    labelKey: "nav.rptComprehensiveIncome",
    icon: "table-view",
    path: "/reports/comprehensive-income",
    permission: p.incomeView,
  },
  {
    key: "reports.cashFlow",
    labelKey: "nav.rptCashFlow",
    icon: "compare-2",
    path: "/reports/cash-flow",
    permission: p.cashFlowView,
  },
  {
    key: "reports.ratios",
    labelKey: "nav.rptRatios",
    icon: "bar-chart",
    path: "/reports/ratios",
    permission: p.ratiosView,
  },
  {
    key: "reports.versions",
    subGroup: "setup",
    labelKey: "nav.rptVersions",
    icon: "tree",
    path: "/reports/statement-versions",
    permission: p.versionView,
  },
  {
    key: "reports.schedules",
    subGroup: "distribution",
    labelKey: "nav.rptSchedules",
    icon: "calendar",
    path: "/reports/schedules",
    permission: p.scheduleView,
  },
  // Every user has a report inbox (deliveries addressed to them); the API returns only their own.
  { key: "reports.inbox", labelKey: "nav.rptInbox", icon: "inbox", path: "/reports/inbox", public: true },
  {
    key: "reports.archive",
    subGroup: "distribution",
    labelKey: "nav.rptArchive",
    icon: "attachment",
    path: "/reports/issued-documents",
    permission: p.archiveView,
  },
  {
    key: "reports.feeds",
    subGroup: "distribution",
    labelKey: "nav.rptFeeds",
    icon: "chain-link",
    path: "/reports/feed-tokens",
    permission: p.feedView,
  },
];
